import { AfterViewInit, Component, effect, inject, OnInit, ViewChild } from '@angular/core';
import { MatTableDataSource, MatTableModule } from '@angular/material/table';
import { MatSnackBar, MatSnackBarModule } from '@angular/material/snack-bar';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatInputModule } from '@angular/material/input';
import { MatFormFieldModule } from '@angular/material/form-field';
import { FormControl, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { Router } from '@angular/router';
import { MatDialog } from '@angular/material/dialog';
import { DocumentoService } from '../../services/documento.service';
import { AppTitleService } from '../../services/app-title.service';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { Documento, ListadoDocumentoPaginado } from '../../models/Document';
import { SelectionModel } from '@angular/cdk/collections';
import { MatSelectModule } from '@angular/material/select';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE } from '@angular/material/core';
import { DocumentTypeService } from '../../services/document-type.service';
import { DocumentType } from '../../models/DocumentType';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatPaginator, MatPaginatorIntl, MatPaginatorModule } from '@angular/material/paginator';
import { catchError, EMPTY, map, merge, startWith, switchMap } from 'rxjs';
import { MatSort, MatSortModule } from '@angular/material/sort';
import { DateService, MY_DATE_FORMATS } from '../../shared/date.service';
import { ScnackbarData, ToastService, SnackbarStyles } from '../../commons/toast.service';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MomentDateAdapter, MAT_MOMENT_DATE_ADAPTER_OPTIONS } from '@angular/material-moment-adapter';
import { EstadosDocumentoComponent } from "../../commons/estados-documento/estados-documento.component";
import { ReportService } from '../../services/report.service';
import { CustomPaginator } from '../../commons/custom-paginator/custom-paginator';
import { AutofocusDirective } from '../../helpers/autofocus.directive';
import { NoDataFoundComponent } from '../../commons/no-data-found/no-data-found.component';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatGridListModule } from '@angular/material/grid-list';
import { MatCardModule } from '@angular/material/card';
import { UtilService } from '../../services/util.service';

export interface FilterData {
  initialDate: string
  endDate: string
  searchText: string
  numero?: string
  documentType: number,
  idBuzon?: number | null
}

@Component({
  selector: 'app-borrador',
  imports: [
    MatCardModule,
    MatTableModule, MatPaginatorModule, MatSortModule,
    MatSnackBarModule,
    MatToolbarModule, MatButtonModule, MatIconModule,
    MatInputModule, MatFormFieldModule,
    FormsModule, ReactiveFormsModule,
    MatSelectModule, AutofocusDirective,
    MatDatepickerModule, NoDataFoundComponent,
    MatCheckboxModule, MatProgressBarModule,
    MatTooltipModule,
    MatProgressSpinnerModule,
    EstadosDocumentoComponent
  ],
  providers: [
    { provide: MatPaginatorIntl, useClass: CustomPaginator },
    { provide: MAT_DATE_LOCALE, useValue: 'es-EC' },
    {
      provide: DateAdapter,
      useClass: MomentDateAdapter,
      deps: [MAT_DATE_LOCALE, MAT_MOMENT_DATE_ADAPTER_OPTIONS]
    },
    { provide: MAT_DATE_FORMATS, useValue: MY_DATE_FORMATS },
  ],
  templateUrl: './borrador.component.html',
  styleUrl: './borrador.component.scss'
})
export class BorradorComponent implements OnInit, AfterViewInit {
  displayedColumns: string[] = ['select', 'movimiento', 'estados', 'asunto', 'fecha', 'numeroDocumento'];
  documentsPaginated: ListadoDocumentoPaginado | undefined
  dataSource = new MatTableDataSource<Documento>([]);
  selection = new SelectionModel<Documento>(true, []);

  @ViewChild(MatPaginator) paginator!: MatPaginator;
  @ViewChild(MatSort) sort!: MatSort;

  resultsLength = 0;
  isLoadingResults = true;

  documentTypes: DocumentType[] | undefined

  dateRangeInWeeks = 5
  initialDate = "2025-01-02"
  maxDate = new Date()

  snackbarData: ScnackbarData = {}

  tipoBandeja = "0"

  filterForm = new FormGroup({
    numero: new FormControl('', [Validators.pattern('^(?:\\d{4}-)?\\d+$')]),
    fechaInicio: new FormControl(new Date(), {
      validators: [
        Validators.required
      ]
    }),
    fechaFin: new FormControl(new Date(), {
      validators: [
        Validators.required,
      ]
    }),
    searchText: new FormControl(""),
    documentType: new FormControl("")
  })

  utilService = inject(UtilService)
  contadorTareas = -1

  constructor(
    private documentoSrv: DocumentoService,
    private documentTypeService: DocumentTypeService,
    private router: Router,
    private reportService: ReportService,
    public dialog: MatDialog,
    private toast: ToastService,
    private dateService: DateService
  ) {
    inject(AppTitleService).setTitle("En Elaboraci\u00f3n");
    effect((e:any) => {
      const contTareas:any = this.utilService.signalTasks();
      if(!this.contadorTareas) { return}      
      if (!contTareas.recibido) {
        return; 
      }
      if (this.contadorTareas == -1) { 
        this.contadorTareas = contTareas.recibido;
        return;
      }
      if (this.contadorTareas != contTareas) {
        this.contadorTareas = contTareas.recibido;
        this.reload();
      }      
    });
  }

  ngOnInit(): void {
    const currentDate = new Date()
    let initialDate = new Date(this.initialDate)
    //initialDate.setDate(currentDate.getDate() - this.dateRangeInWeeks * 7)
    this.filterForm.controls.fechaFin.setValue(currentDate)
    this.filterForm.controls.fechaInicio.setValue(initialDate)
  }

  ngAfterViewInit(): void {

    this.sort.sortChange.subscribe(() => (this.paginator.pageIndex = 0));

    this.documentTypeService.list().subscribe({
      next: (response: DocumentType[]) => {
        this.documentTypes = response;
        let documentTypeDescription = "Oficio"

        const defaultType = this.documentTypes.find(type => type.descripcion === documentTypeDescription);

        if (defaultType) {
          this.filterForm.controls.documentType.setValue("-1")

          merge(this.sort.sortChange, this.paginator.page).pipe(
            startWith({}),
            switchMap(() => {
              this.isLoadingResults = true;
              const filterData = this.createFilterData()
              return this.documentoSrv!.getListadoDocumentosBandeja(
                this.tipoBandeja,
                filterData.initialDate,
                filterData.endDate,
                filterData.searchText,
                filterData.documentType,
                filterData.idBuzon!,
                null,
                this.paginator.pageIndex + 1,
              ).pipe(catchError(() => EMPTY));
            }),
            map(data => {
              this.isLoadingResults = false;
              if (data === null) {
                return [];
              }
              this.resultsLength = data.totalDocumentos;
              return data;
            })
          ).subscribe({
            next: (response) => {
              this.documentsPaginated = response as ListadoDocumentoPaginado
              this.dataSource = new MatTableDataSource<Documento>(this.documentsPaginated.documentos)

              Object.keys(this.filterForm.controls).forEach(controlName => {
                if (controlName !== "searchText" && controlName !== "numero") {
                  this.filterForm.get(controlName)?.valueChanges.subscribe(_ => {
                    this.onControlValueChanged();
                  });
                }
              });
            }
          })
        }
      }
    });
  }

  onKeyUp(e: Event) {
    const codeKey: any = e;
    codeKey.which !== 13
      ? e.preventDefault()
      : this.onControlValueChanged();
  }

  onClear(): void {
    this.filterForm.controls.searchText.setValue("")
    this.onControlValueChanged()
  }

  onControlValueChanged(): void {
    this.filterForm.controls.numero.setValue("");
    this.dataSource = new MatTableDataSource<Documento>([])
    this.fectchAndInitializeDataSource()
  }

  reload() {
    this.filterForm.controls.numero.setValue("");
    this.dataSource = new MatTableDataSource<Documento>([])
    this.fectchAndInitializeDataSource();
  }

  onKeyUpFlow(e: Event) {
    const codeKey: any = e;
    codeKey.which !== 13
      ? e.preventDefault()
      : this.buscarFlow();
  }

  buscarFlow() {
    this.filterForm.controls.searchText.setValue("")
    this.dataSource = new MatTableDataSource<Documento>([])
    this.fectchAndInitializeDataSource();
  }

  fectchAndInitializeDataSource() {
    this.isLoadingResults = true;
    this.paginator.pageIndex = 0
    const filterData = this.createFilterData()
    this.documentoSrv!.getListadoDocumentosBandeja(
      this.tipoBandeja,
      filterData.initialDate,
      filterData.endDate,
      filterData.searchText,
      filterData.documentType,
      null,
      filterData.numero ? filterData.numero : null,
      this.paginator.pageIndex + 1,
    ).subscribe({
      next: (response) => {
        this.documentsPaginated = response as ListadoDocumentoPaginado
        this.dataSource = new MatTableDataSource<Documento>(this.documentsPaginated.documentos)
        this.resultsLength = this.documentsPaginated.totalDocumentos;
        this.isLoadingResults = false;
      }
    })
  }

  private createFilterData(): FilterData {
    const filterData: FilterData = {
      initialDate: this.dateService.formatDateToCustomString(this.filterForm.controls.fechaInicio.value!),
      endDate: this.dateService.formatDateToCustomString(this.filterForm.controls.fechaFin.value!),
      documentType: parseInt(this.filterForm.controls.documentType.value!),
      numero: this.filterForm.controls.numero.value ?? undefined,
      searchText: this.filterForm.controls.searchText.value!
    }
    return filterData
  }

  reAsign() {
    if (this.selection.selected.length === 0) {
      this.snackbarData.message = "Seleccione al menos un documento!"
      this.snackbarData.style = SnackbarStyles.Warning
      this.snackbarData.iconName = "warning"
      this.toast.show(this.snackbarData)
      return
    }
    const taskData = {
      documentIDs: this.selection.selected.map(document => document.idTarea),
    }
    this.router.navigateByUrl("/documento/reasignar", { state: taskData })
  }

  archivar() {
    if (this.selection.selected.length === 0) {
      this.snackbarData.message = "Seleccione al menos un documento!"
      this.snackbarData.style = SnackbarStyles.Warning
      this.snackbarData.iconName = "warning"
      this.toast.show(this.snackbarData)
      return
    }
    const taskData = {
      documentIDs: this.selection.selected.map(document => document.idTarea),
    }
    this.router.navigateByUrl("/documento/archivar", { state: taskData })
  }

  onAddComment() {
    if (this.selection.selected.length === 0) {
      this.snackbarData.message = "Seleccione al menos una tarea"
      this.snackbarData.style = SnackbarStyles.Warning
      this.snackbarData.iconName = "warning"
      this.toast.show(this.snackbarData)
      return
    }
    const taskData = {
      documentIDs: this.selection.selected.map(document => document.idTarea),
    }
    this.router.navigateByUrl("comentar", { state: taskData })
  }

  onAddTask() {
    if (this.selection.selected.length === 0) {
      this.snackbarData.message = "Seleccione al menos un documento!"
      this.snackbarData.style = SnackbarStyles.Warning
      this.snackbarData.iconName = "warning"
      this.toast.show(this.snackbarData)
      return
    }
    const taskData = {
      documentIDs: this.selection.selected.map(document => document.idTarea),
    }
    this.router.navigateByUrl("tarea", { state: taskData })
  }

  clickedRow(row: Documento) {
    this.router.navigateByUrl("/finalizar/" + row.idTarea)
  }

  isAllSelected() {
    const numSelected = this.selection.selected.length;
    const numRows = this.dataSource!.data.length;
    return numSelected === numRows;
  }

  toggleAllRows() {
    if (this.isAllSelected()) {
      this.selection.clear();
      return;
    }
    this.selection.select(...this.dataSource!.data);
  }

  checkboxLabel(row?: Documento): string {
    if (!row) {
      return `${this.isAllSelected() ? 'deselect' : 'select'} all`;
    }
    return `${this.selection.isSelected(row) ? 'deselect' : 'select'} row ${row.id + 1}`;
  }

  formatDate(date: string): string {
    return this.dateService.formatCustomStringToDate(date)
  }

  onCallReport() {
    //https://127.0.0.1:8443/dfwreportes/rs/rpt/listadotipodocumento?P_CODIGO_TIPO_DOC=3
    var params = {
      P_CODIGO_TIPO_DOC: 3
    }
    var url: any = this.reportService.getUrl("listadotipodocumento", params);
    window.open(url, "_blank");
  }

}
